import React from 'react'
import { TextField } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

const AntSwitch = withStyles((theme) => ({
    root: {
        width: 28,
        height: 16,
        padding: 0,
        display: 'flex',
    },
    switchBase: {
        padding: 2,
        color: theme.palette.grey[500],
        '&$checked': {
            transform: 'translateX(12px)',
            color: theme.palette.common.white,
            '& + $track': {
                opacity: 1,
                backgroundColor: theme.palette.primary.main,
                borderColor: theme.palette.primary.main,
            },
        },
    },
    thumb: {
        width: 11,
        height: 12,
        boxShadow: 'none',
    },
    track: {
        border: `1px solid ${theme.palette.grey[500]}`,
        borderRadius: 16 / 2,
        opacity: 1,
        backgroundColor: theme.palette.common.white,
        height: "auto",
        paddingTop: 2,
        paddingBottom: 2
    },
    checked: {},
}))(Switch);

export const CustomTextInput = ({ getValue, onChangeHandler, label, customStyle, isDisabled }) => {
    return (
        <TextField
            label={label}
            size="small"
            variant='outlined'
            value={getValue}
            onChange={(e) => onChangeHandler(e.target.value)}
            style={{ marginBottom: 20, width: 350, ...customStyle }}
            disabled={isDisabled ? true : false}
        />)
}

export const CustomNumberInput = ({ getValue, onChangeHandler, label, customStyle }) => {
    const inputHandler = (e) =>{
        onChangeHandler((prev) => {
            const value = e.target.value
            const isValidInput = /^[0-9]*$/.test(value);
            const parsedValue = parseInt(value)
            return isValidInput && !isNaN(parsedValue) ? parsedValue : value ? value.slice(0, -1) : ""
        })
    }
    
    return (<TextField
        label={label}
        size="small"
        variant='outlined'
        value={getValue}
        onChange={(e) => inputHandler(e)}
        onBlur={(e) => inputHandler(e)}
        style={{ marginBottom: 20, width: 350, ...customStyle }}
    />)
}

export const CustomSwitch = ({ getValue, onChangeHandler, label, customStyle }) => {
    return (
        <Typography component="div" style={{ marginBottom: 20, ...customStyle }}>
            <Grid component="label" container alignItems="center" spacing={1}>
                <Grid item>
                    <AntSwitch checked={getValue} onChange={(e) => onChangeHandler(e.target.checked)} name="checkedC" />
                </Grid>
                <Grid item>{label}</Grid>
            </Grid>
        </Typography>
    )
}

